<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3SytTF/tc-custom/9781468315615.jpg?1700800128532" alt="This image is the cover for the book Whispered Name, Father Anselm Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Whispered Name, Father Anselm Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>Gold Dagger Award Winner: “This complex thriller . . . explores some of life’s biggest moral questions and puts a human face on the war to end all wars.” —</b><i>Kirkus Reviews</i><br/><br/>A <i>Wall Street Journal</i> Best Mystery of the Year<br/><br/>In the Larkwood Priory, secrets are rare. So Father Anselm is deeply dismayed by an allegation against the late Herbert Moore, one of the founding fathers of the Priory and the man who shaped his own vocation. The claim is inconceivable, but Anselm soon learns that Herbert did indeed have secrets in his past that he kept hidden all his life.<br/><br/>While investigating the accusation, former lawyer Father Anselm discovers the horrors of a long-buried secret of war involving the young Captain Moore. A novel of moral complexity, superb characterization and, above all, profound humanity, <i>A Whispered Name</i> is fit to stand with the finest thrillers inspired by the First World War.<br/><br/>“<i>A Whispered Name </i>holds its own?in moral purpose and expressive prose?with the best of Graham Greene.” —<i>The Wall Street Journal</i><br/><br/>“Poignant . . . with incredible pacing . . . a thought-provoking, nuanced story.” —<i>Publishers Weekly</i><br/><br/>“William Brodrick’s crime novels have the great (and unusual) merit of being unlike anyone else’s.” —<i>Spectator</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William Brodrick
      </h2>
      
      <p class="authorDescription body article">William Brodrick was an Augustinian friar before leaving the order to become a lawyer and novelist. Winner of the Crime Writers’ Association Gold Dagger Award, he is the author of six novels featuring Father Anselm.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33e1e647